import { RouterProvider } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { queryClient } from "@/lib/queryClient";
import { AuthProvider } from "@/auth/AuthProvider";
import { router } from "@/routes/router";
import { ActiveRemoteAssistOverlay } from "@/features/remoteAssist/components/ActiveRemoteAssistOverlay";


export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ActiveRemoteAssistOverlay />
        <RouterProvider router={router} future={{ v7_startTransition: true }} />
      </AuthProvider>
      {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  );
}
